import { visit } from 'unist-util-visit';
import type { Element, Root } from 'hast';

// Marks fenced ```mermaid code blocks as `<div class="mermaid">` so the client-side
// mermaid renderer (see modules/mermaid/mermaidRenderer.ts) can find and draw them.
export function rehypeMermaidBlocks() {
  return (tree: Root) => {
    visit(tree, 'element', (node: Element, index, parent) => {
      if (
        node.tagName !== 'code' ||
        !parent ||
        index === undefined ||
        index === null
      ) {
        return;
      }

      const className = (node.properties?.className ?? []) as string[];
      if (!className.includes('language-mermaid')) return;

      const source = node.children
        .filter((child): child is { type: 'text'; value: string } => child.type === 'text')
        .map(child => child.value)
        .join('');

      parent.children[index] = {
        type: 'element',
        tagName: 'div',
        properties: { className: ['mermaid'] },
        children: [{ type: 'text', value: source }],
      } as Element;
    });
  };
}
